import * as React from "react";
const CloseSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M15.2928932,3.99989322 L16,4.707 L10.7068932,9.99989322 L16.0000534,15.2928398 L15.2929466,15.9999466 L9.99989322,10.7068932 L4.707,16 L3.99989322,15.2928932 L9.29289322,9.99989322 L4,4.707 L4.70710678,3.99989322 L9.99989322,9.29189322 L15.2928932,3.99989322 Z" }));
CloseSmall.displayName = "CloseSmall";
var CloseSmall_default = CloseSmall;
export {
  CloseSmall_default as default
};
